// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#container .page-num[data-v-0d1cd31a]{text-align:center;font-size:14px}", ""]);
// Exports
module.exports = exports;
